import { useChatAuthorization } from "@faire/help-center-self-serve/chat/hooks/useChatAuthorization";
import { Anchor } from "@faire/web--source/ui/LinkAnchor";
import React from "react";

import { DesktopChat, IChatProps } from "../view/Answer/DesktopChat";

interface IMobileChatProps extends IChatProps {
  to: string;
}

export const MobileChat: React.FC<IMobileChatProps> = ({
  to,
  disableChat,
  onClick,
  loading,
}) => {
  const { chatBtnEnabled } = useChatAuthorization();
  const chat = (
    <DesktopChat
      onClick={onClick}
      disableChat={disableChat}
      loading={loading}
    />
  );

  if (!chatBtnEnabled) {
    return chat;
  }

  return (
    <Anchor href={to} data-test-id="mobile-chat-link">
      {chat}
    </Anchor>
  );
};
